<template>
  <div>
    {{page.numPage}}-{{page.state}}-{{page.visible}}-{{top}}-{{bottom}}
    <div class="pdf-page" :style="{height:defaultHeight+'px',width:defaultHeight+'px'}" v-if="page.state!='rendered'">
        rosco...
    </div>
    <PDFCanvasV2  v-if="shouldRender" :page="page"/>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";

import PDFCanvasV2 from './PDFCanvasV2.vue'
import throttle from 'lodash/throttle';


export default {
  name: 'PDFPageV2',
  props:{
    page: {
      type: Object, // instance containing an instance of  PDFPageProxy returned from pdf.getPage
      required: true,
    },
  },
  components: {
    PDFCanvasV2,
  },
  data() {
    return {
        top:undefined,
        bottom:undefined,
        visible:false,
        throttledScroll:undefined,
      
    };
  },
  computed: {
      ...mapState("pdf_data",[
      'defaultWidth',
      'defaultHeight',
    ]),
    shouldRender(){
        return ['downloaded','rendering','rendered'].includes(this.page.state)
    }
    
  },
  methods: {
    updateBoundingBox(){
      console.log('updateBoundingBox:'+this.page.numPage)
        const element=this.$el
        var position = element.getBoundingClientRect()
        this.top = position.top
        this.bottom = position.bottom
        if(position.top < window.innerHeight && position.bottom >= 0) {
		    this.setVisible()
            
	    }else{
            this.setNotVisible()
        }
    },
    setNotVisible(){
        if(this.visible){
            this.visible=false;
            this.visibilityChanged(this.visible)
        }    
    },
    setVisible(){
        if(!this.visible)
        {
            this.visible=true;
            this.visibilityChanged(this.visible)
        }
    },
    visibilityChanged(visible){
        console.log(`${this.page.numPage} ${visible}`)
        this.setPageVisible({numPage:this.page.numPage,visible})
    },
    ...mapActions({
      setPageVisible: "pdf_data/setPageVisible",
    })  
  },
  created() {
  },
  mounted(){

      //     function inserted(el, binding) {
      //   const callback = binding.value;
      //   if (binding.modifiers.immediate) {
      //     callback();
      //   }
      //   const throttledScroll = throttle(callback, 1000);
      //   el.addEventListener('scroll', throttledScroll, true);
      // }
      this.throttledScroll = throttle(this.updateBoundingBox, 1000);
      window.addEventListener('scroll',this.throttledScroll)//try ,true
  },
  beforeDestroy(){
    console.log("before destroy pdf page")
    window.removeEventListener('scroll',this.throttledScroll)
  },
  updated(){
  },
  destroyed() {
      
    
  },

}
</script>

<style scoped>
.pdf-page {
  display: block;
  margin: 0 auto;
  background-color: #ffffff;
}
</style>